import React, { useState, useEffect } from "react";
import * as Icon from "react-bootstrap-icons";
import { motion } from "framer-motion";
import ContentLoader from "react-content-loader";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { closeMenu, setLang } from "../../../stores/mainSlice";

const Menu = () => {
  const [isMenusLoading, setIsMenusLoading] = useState(true);
  const [menus, setMenus] = useState([]);
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.mainSlice.lang);
  const open = useSelector((state) => state.mainSlice.menu);
  const location = useLocation();

  const list = {
    visible: {
      opacity: 1,
      transition: {
        type: "spring",
        when: "",
        staggerChildren: 0.3,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };
  const item = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 50 },
  };
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/main/header-menu/menus/`)
      .then((res) => {
        setMenus(res.data["children"]);
      })
      .then(() => {
        setIsMenusLoading(false);
      });
  }, []);

  useEffect(() => {
    dispatch(closeMenu());
  }, [location]);

  return (
    <motion.div
      variants={list}
      initial="hidden"
      animate="visible"
      className={`container middle mobile-menu-wrapper ${open ? "open" : ""}`}
    >
      <div className="row">
        <div className="col-12">
          {isMenusLoading === true ? (
            <div className="w-100 m-auto">
              <div style={{ width: "70%", margin: "auto" }}>
                <ContentLoader viewBox="0 0 306 13" className="mb-1">
                  <rect x="0" y="0" rx="0" ry="0" width="100%" height="13" />
                </ContentLoader>
              </div>
            </div>
          ) : (
            <ul className="main-menu">
              {menus.map((menu, index) => (
                <motion.li
                  transition={{ duration: 0.5 }}
                  variants={item}
                  key={index}
                >
                  {menu["children"].length !== 0 ? (
                    <a>
                      {lang === "en"
                        ? menu["name_en"]
                        : lang === "ru"
                        ? menu["name_ru"]
                        : menu["name_tm"]}{" "}
                      <Icon.ChevronDown />
                    </a>
                  ) : (
                    <Link to={menu["url"]}>
                      {lang === "en"
                        ? menu["name_en"]
                        : lang === "ru"
                        ? menu["name_ru"]
                        : menu["name_tm"]}{" "}
                    </Link>
                  )}
                  {menu["children"].length !== 0 ? (
                    <div className="submenu">
                      <ul>
                        {menu["children"].map((inner_menu) => (
                          <li key={inner_menu["id"]}>
                            <Link to={inner_menu["url"]}>
                              {lang === "en"
                                ? inner_menu["name_en"]
                                : lang === "ru"
                                ? inner_menu["name_ru"]
                                : inner_menu["name_tm"]}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                </motion.li>
              ))}
              <motion.li
                transition={{ duration: 0.5 }}
                variants={item}
                className="position-relative search-icon-wrapper d-none"
              >
                <button className="clear-btn search-btn">
                  <Icon.Search />
                </button>
                <div className="search-form-wrapper">
                  <form action="">
                    <input type="text" name="word" />
                    <button className="clear-btn">
                      <Icon.Search />
                    </button>
                  </form>
                </div>
              </motion.li>
              <motion.li
                transition={{ duration: 0.5 }}
                variants={item}
                className="position-relative search-icon-wrapper"
              >
                <Link to={`https://migration.gov.tm/feed/latest/${lang}`} target="_blank" className="clear-btn">
                  <Icon.RssFill style={{width: "20px", height: "20px", fill: '#ee802f'}} />
                </Link>
              </motion.li>
              <motion.li transition={{ duration: 0.5 }} variants={item}>
                <div className="langs-wrapper">
                  <span
                    className={lang === "tm" ? "active" : ""}
                    onClick={() => {
                      localStorage.setItem("lang", "tm");
                      dispatch(setLang("tm"));
                    }}
                  >
                    TM
                  </span>
                  <span
                    className={lang === "ru" ? "active" : ""}
                    onClick={() => {
                      localStorage.setItem("lang", "ru");
                      dispatch(setLang("ru"));
                    }}
                  >
                    RU
                  </span>
                  <span
                    className={lang === "en" ? "active" : ""}
                    onClick={() => {
                      localStorage.setItem("lang", "en");
                      dispatch(setLang("en"));
                    }}
                  >
                    EN
                  </span>
                </div>
              </motion.li>
            </ul>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Menu;
